import { AddIcon, CloseIcon, SearchIcon, ChevronDownIcon, InfoOutlineIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Icon,
  IconButton,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Spinner,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useDisclosure,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Tooltip,
  useToast,
  useColorModeValue,
} from "@chakra-ui/react";
import Pagination from "components/drive/PaginationForDrive";
import SidebarWithHeader from "components/SidebarWithHeader";
import UploadModal from "components/StatusUploadModal";
import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { FaPlayCircle } from "react-icons/fa";
import { FiEye, FiGrid, FiList } from "react-icons/fi";
import { TbRefresh } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useFetchImagesQuery, useFetchVideosQuery } from "store/driveUpload/uploadApi";
import {
  selectAfter,
  selectBefore,
  setAfter,
  setBefore,
  selectCurrentPage,
  setCurrentPage,
} from "store/campaigns/campaignsSlice";
import { useGetBmAdAccountsCountQuery, useGetBmAdAccountsQuery } from "store/BmAccounts/bmAccountApi";
import {
  selectSelectedAdAccounts,
  selectAdAccountAssigned,
  selectAdAccountLoading,
  selecthasAdAccountChecked,
  selectSelectedBmAccounts,
} from "store/BmAccounts/bmAccountSlice";
import SearchAdaccount from "components/bmControl/SearchAdaccount";
import { setFiles, setIsWidgetOpen, updateUploadStatus } from "store/driveUpload/uploadSlice";
import { BsStars } from "react-icons/bs";

const DriveForClient = () => {
  const listBg = useColorModeValue("brand.100", "gray.700");
  const listHoverBg = useColorModeValue("gray.300", "gray.600");
  const activeBg = "brand.500";
  const tabBg = useColorModeValue("white", "transparent");
  const tabBorder = useColorModeValue("brand.200", "brand.400");
  const tabSelectedBg = useColorModeValue("brand.100", "brand.600");
  const tabSelectedText = useColorModeValue("white", "brand.900");

  const inputRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const [searchParams] = useSearchParams();
  const params = new URLSearchParams(location.search);
  const adsAccountIdFromParams = searchParams.get("adsAccountId");
  const businessId = searchParams.get("business_id");
  const [showError, setShowError] = useState(false);
  const [view, setView] = useState("grid");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [previewFile, setPreviewFile] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const after = useSelector(selectAfter);
  const before = useSelector(selectBefore);
  const currentPage = useSelector(selectCurrentPage);
  const [debouncedSearchValue, setDebouncedSearchValue] = useState(searchValue);
  const [selectedAdsAccountId, setSelectedAdsAccountId] = useState("");
  const [selectedTab, setSelectedTab] = useState(params.get("tab") ? params.get("tab") : "images");
  const userActiveAdaccounts = useSelector((state) => state.auth?.activeAdAccounts);
  const selectedAdAccounts = useSelector(selectSelectedAdAccounts);
  const adAccountLoading = useSelector(selectAdAccountLoading);
  const hasActiveAdAccount = useSelector((state) => state.auth?.hasActiveAdAccount);
  const hasAdAccountAssigned = useSelector(selectAdAccountAssigned);
  const hasAdAccountChecked = useSelector(selecthasAdAccountChecked);
  const bmAccount = useSelector(selectSelectedBmAccounts);
  const [mediaType, setMediaType] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [afterValue, setAftervalue] = useState("");

  const { data: accountsCount } = useGetBmAdAccountsCountQuery();
  const totalCount = accountsCount?.summary?.total_count ?? 20;
  const isSearching = !!searchTerm?.trim();
  const effectivePageSize = isSearching ? String(totalCount) : "20";

  const {
    data: AdAccountData,
    refetch: refetchAdaccountData,
    isLoading: isAdAccountLoading,
    isFetching: isAdAccountFetching,
    error: AdAccountError,
    isError: isAdaccountError,
  } = useGetBmAdAccountsQuery({
    search: searchTerm ? searchTerm : "",
    pageSize: effectivePageSize,
    after: searchTerm ? "" : afterValue,
  });

  const {
    data: images,
    isLoading: isImagesDataLoading,
    isFetching: isImagesFetching,
    refetch: refetchImages,
    error: isImageError,
  } = useFetchImagesQuery(
    {
      pageSize: "27",
      ...(searchValue ? {} : { after, before }),
      searchValue: debouncedSearchValue,
      adsAccountId: selectedAdsAccountId,
    },
    { skip: !selectedAdsAccountId || selectedTab !== "images" }
  );

  const {
    data: videos,
    isLoading: isVideosDataLoading,
    refetch: refetchVideos,
    isFetching: isVideosFetching,
    error: isVideoError,
  } = useFetchVideosQuery(
    {
      pageSize: "27",
      ...(searchValue ? {} : { after, before }),
      searchValue: debouncedSearchValue,
      adsAccountId: selectedAdsAccountId,
    },
    { skip: !selectedAdsAccountId || selectedTab !== "videos" }
  );

  useEffect(() => {
    if (AdAccountError) {
      toast({
        position: "top-right",
        title: "Error",
        description: AdAccountError?.data?.message,
        status: "error",
        duration: 4000,
        isClosable: true,
      });

      navigate("/launchpad");
    }
  }, [AdAccountError]);

  useEffect(() => {
    if (businessId) {
      refetchAdaccountData();
      setSearchTerm("");
    }
  }, [businessId]);

  useEffect(() => {
    if (hasSearched && searchTerm === "") {
      refetchAdaccountData();
    }
  }, [searchTerm]);

  useEffect(() => {
    if (selectedAdsAccountId) {
      params.set("adsAccountId", selectedAdsAccountId);
    }
    navigate({ search: params.toString() }, { replace: true });
  }, [selectedAdsAccountId]);

  const handleAdaccountChange = (value) => {
    if (value?.value !== selectedAdsAccountId) {
      setSelectedAdsAccountId(value?.value);

      dispatch(setAfter(""));
      dispatch(setBefore(""));
      dispatch(setCurrentPage(0));
      localStorage.removeItem("after");
      localStorage.removeItem("before");
      setSearchValue("");
    }
  };

  const handleSearchChange = useCallback((value) => {
    setSearchTerm(value);
  }, []);

  const handleMediaTypeChange = (value) => {
    setMediaType(value);
    if (value) {
      onOpen();
      dispatch(updateUploadStatus({}));
      dispatch(setIsWidgetOpen(false));
      dispatch(setFiles([]));
    }
  };

  const handleRefresh = () => {
    if (selectedTab === "images") {
      refetchImages();
    } else {
      refetchVideos();
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 800);

    return () => {
      clearTimeout(handler); // Cleanup timeout if searchValue changes before 800ms
    };
  }, [searchValue]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchValue?.length > 2 || searchValue?.length === "") {
        setSearchValue(searchValue);
      }
    }, 4000);

    return () => clearTimeout(delayDebounceFn);
  }, [searchValue]);

  useEffect(() => {
    if (showError) {
      setTimeout(() => {
        setShowError(false);
      }, 3000);
    }
  }, [showError]);

  useEffect(() => {
    if (searchValue.trim() === "") {
      setSearchValue("");
      setShowError(false);
      return;
    }

    const hasResults =
      (selectedTab === "images" &&
        images?.data?.some((file) =>
          file?.name?.toLowerCase().includes(searchValue.toLowerCase())
        )) ||
      (selectedTab === "videos" &&
        videos?.data?.some((file) =>
          file?.name?.toLowerCase().includes(searchValue.toLowerCase())
        ));

    setShowError(!hasResults);
  }, [searchValue, images, videos]);

  const handleFileClick = (file) => {
    if (file) {
      setPreviewFile({
        ...file,
        type: file.creativeType,
        value: file.creativeType === "image" ? file.url : file.source,
      });
      setIsPreviewOpen(true);
    }
  };

  //callback for video upload

  const handleUploadSuccess = async () => {
    if (selectedTab === "images") {
      refetchImages();
    } else if (selectedTab === "videos") {
      refetchVideos();
    }
  };

  const imageList = images?.data.map((file, index) => {
    return (
      <Flex
        direction={view == "grid" ? "column" : "row"}
        alignItems={view === "grid" ? "inherit" : "center"}
        key={index}
        pb={view === "grid" ? 0 : 2}
      >
        <Box
          bgColor={view === "grid" ? "gray.50" : ""}
          borderRadius={view === "grid" ? "lg" : "unset"}
          borderBottomColor={view === "grid" ? "unset" : "gray.50"}
          borderBottomWidth={view === "grid" ? 0 : 1}
        >
          {view === "grid" ? (
            <Flex
              w="100%"
              h="110px"
              direction={"column"}
              display="flex"
              alignItems="center"
              justifyContent="center"
              position="relative"
              borderRadius={3}
              p={"2px"}
              overflow={"hidden"}
              onClick={() => {
                handleFileClick(file);
              }}
            >
              {file.url ? (
                <>
                  <Image
                    src={file.url}
                    alt={file.name}
                    objectFit="cover"
                    width="100%"
                    height="100%"
                    borderRadius="3px"
                  />

                  {/* AI Generated Icon */}
                  {file.aiGenerated && (
                    <Tooltip label="AI Generated" fontSize="xs" hasArrow placement="right">
                      <Box
                        position="absolute"
                        top="4px"
                        right="4px"
                        zIndex="2"
                        bg="gray.800"
                        borderRadius="full"
                        border="1px solid #fff"
                        p="3px"
                      >
                        <BsStars size={13} color="#fff" />
                      </Box>
                    </Tooltip>
                  )}
                  <Flex
                    position="absolute"
                    top="0"
                    left="0"
                    w="100%"
                    h="100%"
                    alignItems="center"
                    justifyContent="center"
                    bgColor="rgba(0, 0, 0, 0.3)"
                    opacity="0"
                    _hover={{
                      opacity: 1,
                      cursor: "pointer",
                    }}
                  >
                    <FiEye size={18} color="white" />
                  </Flex>
                </>
              ) : null}
            </Flex>
          ) : (
            <>
              {file?.url ? (
                <Box maxW={"40px"}>
                  <Image
                    src={file.url}
                    alt={file.name}
                    objectFit="cover"
                    width="100%"
                    height="100%"
                    borderRadius="3px"
                  />
                </Box>
              ) : null}
            </>
          )}
        </Box>
        <Text fontSize="12px" noOfLines={1} ml={"10px"}>
          {file.name}
        </Text>
      </Flex>
    );
  });

  const videoList = videos?.data.map((file, index) => {
    return (
      <Flex
        key={index}
        direction={view == "grid" ? "column" : "row"}
        alignItems={view === "grid" ? "inherit" : "center"}
        pb={view === "grid" ? 0 : 2}
      >
        <Box
          bgColor={view === "grid" ? "gray.50" : ""}
          borderRadius={view === "grid" ? "lg" : "unset"}
          borderBottomColor={view === "grid" ? "unset" : "gray.50"}
          borderBottomWidth={view === "grid" ? 0 : 1}
        >
          <Box
            w="100%"
            h={view == "grid" ? "110px" : "60px"}
            display="flex"
            alignItems={view == "grid" ? "center" : "center"}
            justifyContent="center"
            position="relative"
            borderRadius={3}
            p={"2px"}
            onClick={() => handleFileClick(file)}
          >
            {file.source ? (
              <Box w="100%" h="100%" position="relative">
                <video
                  style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "3px" }}
                  src={file.source}
                  muted
                />

                {/* AI Generated Icon */}
                {file.aiGenerated && (
                  <Tooltip label="AI Generated" fontSize="xs" hasArrow placement="right">
                    <Box
                      position="absolute"
                      top="4px"
                      right="4px"
                      zIndex="2"
                      bg="gray.800"
                      borderRadius="full"
                      border="1px solid #fff"
                      p="3px"
                    >
                      <BsStars size={13} color="#fff" />
                    </Box>
                  </Tooltip>
                )}
                <Flex
                  position="absolute"
                  top="0"
                  left="0"
                  w="100%"
                  h="100%"
                  alignItems="center"
                  justifyContent="center"
                  bgColor="rgba(0, 0, 0, 0.3)"
                  opacity="0"
                  _hover={{
                    opacity: 1,
                    cursor: "pointer",
                  }}
                >
                  <FaPlayCircle color="white" size="18px" />
                </Flex>
              </Box>
            ) : null}
          </Box>
        </Box>
        <Text fontSize="13px" noOfLines={1} ml={2}>
          {file.name}
        </Text>
      </Flex>
    );
  });

  useEffect(() => {
    params.set("page_id", currentPage);
    navigate({ search: params.toString() }, { replace: true });
  }, [currentPage]);

  useEffect(() => {
    const storedPage = params.get("page_id");

    if (storedPage && !isNaN(storedPage)) {
      const parsedPage = parseInt(storedPage, 10);
      if (parsedPage >= 0 && parsedPage !== currentPage) {
        dispatch(setCurrentPage(parsedPage));
      }
    } else if (currentPage !== 0) {
      dispatch(setCurrentPage(0));
    }
  }, [location.search]);

  const PageMeta = useMemo(() => {
    const currentMeta =
      selectedTab === "images" ? images?.meta : selectedTab === "videos" ? videos?.meta : null;

    return currentMeta || {};
  }, [images, videos]);

  const handlePageChange = ({ after, before, currentPage }) => {
    if (after) {
      dispatch(setAfter(after));
      dispatch(setBefore(""));
    } else if (before) {
      dispatch(setBefore(before));
      dispatch(setAfter(""));
    }

    dispatch(setCurrentPage(currentPage));
  };

  // if (adAccountLoading) {
  //     return (
  //       <SidebarWithHeader>
  //         <Flex justify="center" align="center" height="80vh">
  //           <Spinner size="md" />
  //         </Flex>
  //       </SidebarWithHeader>
  //     );
  // }

  const handleLoadMore = (after) => {
    setAftervalue(after);
  };

  const hoverBackground = useColorModeValue("purple.200", "brand.800");
  const hoverIconColor = useColorModeValue("brand.900", "brand.300");
  const navBackground = useColorModeValue("purple.500", "brand.500");
  const navTextColor = useColorModeValue("brand.900", "brand.500");
  const activeTextColor = useColorModeValue("white", "brand.900");
  const textColor = useColorModeValue("brand.900", "brand.500");
  const textColorSub = useColorModeValue("brand.300", "brand.700");

  return (
    <>
      <SidebarWithHeader>
        {isAdaccountError ? (
          <Flex justify="center" align="center" height="80vh">
            <Text color="red.500">
              {/* {AdAccountError?.data?.message} */}
              Please disconnect and reconnect your Facebook Business Manager account to continue
              accessing the platform.
            </Text>
          </Flex>
        ) : (
          // ) : (isAdAccountLoading) ? (
          //     <Flex justify="center" align="center" height="80vh">
          //         <Spinner mt="20px" />
          //     </Flex>
          <>
            {/* Header */}
            <Flex
              mb="10px"
              alignItems={["flex-start", "center"]}
              justifyContent="space-between"
              flexDirection={["column", "row"]}
              gap={[3, 0]}
              flexWrap="wrap"
            >
              <Flex
                alignItems="center"
                flexBasis={["100%", "70%"]}
                flexWrap="wrap"
                gap={3}
              >
                <Heading as="h1" size="xl" color={textColor}>
                  My Drive
                </Heading>
                <Menu>
                  <MenuButton
                    size="sm"
                    as={Button}
                    colorScheme="brand"
                    _expanded={{ bg: "brand.600" }}
                    rightIcon={<ChevronDownIcon />}
                  >
                    <AddIcon boxSize={3} mr={2} /> Add Media
                  </MenuButton>
                  <MenuList>
                    <MenuItem onClick={() => handleMediaTypeChange("image")} fontSize="14px">
                      Add Image
                    </MenuItem>
                    <MenuItem onClick={() => handleMediaTypeChange("video")} fontSize="14px">
                      Add Video
                    </MenuItem>
                  </MenuList>
                </Menu>
              </Flex>
            </Flex>

            {/* Subheading */}
            <Flex mb={{ base: "8px", md: "10px" }}>
              <Text
                fontSize={'14px'}
                color={textColorSub}
                
              >
                Store your creatives in My Drive of the selected Ad Account(s) for easy access while
                building your campaigns.
              </Text>
            </Flex>

            {/* Search */}
            <Flex alignItems="center">
              <Box width="100%">
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <SearchIcon color="gray.300" />
                  </InputLeftElement>
                  <Input
                    ref={inputRef}
                    type="text"
                    value={searchValue || ""}
                    onChange={(e) => setSearchValue(inputRef.current.value)}
                    placeholder="Search..."
                  />
                  {searchValue && (
                    <InputRightElement
                      cursor="pointer"
                      onClick={() => {
                        setSearchValue("");
                        setShowError(false);
                      }}
                    >
                      {isImagesFetching || isVideosFetching ? (
                        <Spinner />
                      ) : (
                        <CloseIcon fontSize={14} _hover={{ color: "gray.600" }} color="gray.300" />
                      )}
                    </InputRightElement>
                  )}
                </InputGroup>

                {showError && (
                  <Flex direction="column" gap="10px" justify="center" align="center">
                    <Text mt={4} fontSize="sm" color="red.500">
                      No results found. Try a different search term.
                    </Text>
                  </Flex>
                )}
              </Box>
            </Flex>

            <Flex flexDirection={"column"} flex={"1"}>
              <Box mb={"20px"} gap={4}>
                <Box mt={"20px"}>
                  <Tabs
                    size="sm"
                    position="relative"
                    variant="unstyled"
                    sx={{
                      display: "flex",
                      position: "relative",
                      flexDirection: "column",
                      flex: 1,
                    }}
                    index={selectedTab === "images" ? 0 : 1}
                    onChange={(index) => {
                      const newTab = index === 0 ? "images" : "videos";
                      if (newTab !== selectedTab) {
                        params.set("tab", newTab);
                        navigate({ search: params.toString() }, { replace: true });
                        dispatch(setAfter(""));
                        dispatch(setBefore(""));
                        dispatch(setCurrentPage(0));
                        localStorage.removeItem("after");
                        localStorage.removeItem("before");
                        setSelectedTab(newTab);
                        setSearchValue("");
                      }
                    }}
                    isLazy
                  >
                    <Flex justify={"space-between"}
                      direction={{ base: "column", md: "row" }} 
                      gap={{ base: 4, md: 0 }}>
                      <TabList gap={"10px"}>
                        <Tab
                          borderWidth={1}
                          borderRadius={5}
                          colorScheme="brand"
                          border={textColor}
                          _selected={{ color: tabSelectedText, bg: navBackground }}
                        >
                          Images
                        </Tab>
                        <Tab
                          borderWidth={1}
                          borderRadius={5}
                          _selected={{ color: tabSelectedText, bg: navBackground }}
                        >
                          Videos
                        </Tab>
                        <Tooltip label="Refresh" fontSize="xs">
                          <Flex
                            _hover={{
                              color: "gray.400",
                            }}
                            alignItems={"center"}
                          >
                            <TbRefresh cursor="pointer" onClick={handleRefresh} size={20} />
                          </Flex>
                        </Tooltip>
                      </TabList>

                      <Flex gap={2} align="center">
                        <SearchAdaccount
                          onInitialisation={setSelectedAdsAccountId}
                          accountOptions={AdAccountData?.data}
                          onAccountChange={handleAdaccountChange}
                          onSearchInputChange={handleSearchChange}
                          onSearchInputTouched={setHasSearched}
                          AdsAccountIdFromParams={adsAccountIdFromParams}
                          isAdAccountLoading={isAdAccountLoading}
                          isAdAccountFetching={isAdAccountFetching}
                          pageMeta={AdAccountData?.meta}
                          onLoadMore={handleLoadMore}
                        />
                        <Tooltip
                          borderRadius={5}
                          label={
                            <Box fontSize="sm" p="5px">
                              <Text>
                                Select an Ad Account from the dropdown to view media stored in its
                                My Drive.
                              </Text>
                            </Box>
                          }
                          fontSize="md"
                        >
                          <InfoOutlineIcon pointerEvents="all" />
                        </Tooltip>
                      </Flex>
                    </Flex>

                    <Divider borderWidth={1} borderBottomColor={"gray.50"} my={"20px"} />

                    {hasAdAccountAssigned ? (
                      <>
                        <TabPanels pb={"10px"} minHeight="435px">
                          <TabPanel p={0}>
                            {isImagesDataLoading || isImagesFetching ? (
                            <Flex direction={'column'} gap={2} alignItems={'center'} justifyContent={'center'} h={'50vh'}>
                              <Spinner />
                              <Text>Loading…</Text>
                            </Flex>
                            ) : isImageError ? (
                              <Flex justifyContent={"center"} alignItems={"center"} height={"50vh"}>
                                <Text color="red.500" mt="20px">
                                  {/* {"Sorry, images not available at this moment. Try again later."} */}
                                  {isImageError?.data?.message}
                                </Text>
                              </Flex>
                            ) : (
                              <>
                                {images?.data?.length > 0 ? (
                                  <Grid
                                    justifyContent="flex-start" 
                                    templateColumns={{
                                      base: "repeat(auto-fit, minmax(100px, 120px))",
                                      sm: "repeat(auto-fit, minmax(120px, 120px))",
                                    }}
                                    gap={{ base: "12px", md: "20px" }}
                                  >
                                    {imageList}
                                  </Grid>
                                ) : (
                                  <Flex
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                    height={"50vh"}
                                  >
                                    <Text>
                                      No image assets uploaded yet. Click on{" "}
                                      <strong>'Add Media'</strong> to upload
                                    </Text>
                                  </Flex>
                                )}
                              </>
                            )}
                          </TabPanel>
                          <TabPanel p={0}>
                            {isVideosDataLoading || isVideosFetching ? (
                            <Flex direction={'column'} gap={2} alignItems={'center'} justifyContent={'center'} h={'50vh'}>
                              <Spinner />
                              <Text>Loading…</Text>
                            </Flex>
                            ) : isVideoError ? (
                              <Flex justifyContent={"center"} alignItems={"center"} height={"50vh"}>
                                <Text color="red.500" mt="20px">
                                  {/* {"Sorry, videos not available at this moment. Try again later."} */}
                                  {isVideoError?.data?.message}
                                </Text>
                              </Flex>
                            ) : (
                              <>
                                {videos?.data?.length > 0 ? (
                                  <Grid
                                    justifyContent="flex-start" 
                                    templateColumns={{
                                      base: "repeat(auto-fit, minmax(100px, 120px))",
                                      sm: "repeat(auto-fit, minmax(120px, 120px))",
                                    }}
                                    gap={{ base: "12px", md: "20px" }}
                                  >
                                    {videoList}
                                  </Grid>
                                ) : (
                                  <Flex
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                    height={"50vh"}
                                  >
                                    <Text>
                                      No video assets uploaded yet. Click on{" "}
                                      <strong>'Add Media'</strong> to upload
                                    </Text>
                                  </Flex>
                                )}
                              </>
                            )}
                          </TabPanel>
                        </TabPanels>
                        {/* Pagination Component */}
                        <Pagination
                          PageMeta={PageMeta}
                          initialState={{ pageIndex: currentPage }}
                          onPageChange={handlePageChange}
                          isFetching={isImagesFetching || isVideosFetching}
                        />
                      </>
                    ) : (
                      <Flex justify="center" align="center" height="80vh">
                        {/* <Text>No data available</Text> */}
                      </Flex>
                    )}
                  </Tabs>
                </Box>
              </Box>
            </Flex>

            {/* Upload Modal */}
            <UploadModal
              onSuccess={handleUploadSuccess}
              isOpen={isOpen}
              onClose={() => {
                onClose();
                setMediaType("");
              }}
              mediaType={mediaType}
            />

            {/* File Preview Modal */}
            <Modal isOpen={isPreviewOpen} onClose={() => setIsPreviewOpen(false)}>
              <ModalOverlay />
              <ModalContent>
                <ModalHeader fontSize="sm" pr="12" whiteSpace="normal" wordBreak="break-word">
                  {previewFile?.name}
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  {previewFile?.type === "image" ? (
                    <Image
                      src={previewFile.value}
                      alt={previewFile.name}
                      mx={"auto"}
                      width="400px" // Fixed width
                      height="300px" // Fixed height
                      objectFit="contain" // Ensure image fits inside without stretching
                      borderRadius={2}
                    />
                  ) : previewFile?.type === "video" ? (
                    <video
                      controls
                      style={{
                        width: "400px", // Fixed width
                        height: "300px", // Fixed height
                        objectFit: "contain", // Ensure video fits inside without stretching
                      }}
                    >
                      <source src={previewFile.value} />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <Text>No preview available for this file type.</Text>
                  )}
                </ModalBody>
                <ModalFooter></ModalFooter>
              </ModalContent>
            </Modal>
          </>
        )}
      </SidebarWithHeader>
    </>
  );
};

export default DriveForClient;